import {
  BaujahrSpanneInMietspiegeljahr,
  Mietspiegeljahr,
  Preisspanne,
  Wohnflaeche,
  Wohnlage,
} from "./types";

export const preisspannenByMietspiegeljahr = {
  "2015": {
    "-1918": {
      einfach: {
        "-40": [6.48, 4.81, 8.55],
        "40-60": [5.91, 4.51, 7.99],
        "60-90": [5.62, 4.4, 7.52],
        "90-": [5.43, 4.13, 7.42],
      },
      mittel: {
        "-40": [7.18, 5.18, 9.27],
        "40-60": [5.81, 4.34, 7.81],
        "60-90": [5.84, 4.55, 8.1],
        "90-": [5.49, 4.51, 6.99],
      },
      gut: {
        "-40": [5.76, 4.62, 6.9],
        "40-60": [6.51, 5.62, 8.28],
        "60-90": [5.98, 4.84, 7.49],
        "90-": [6.18, 4.72, 8.5],
      },
    },
    "1919-1949": {
      einfach: {
        "-40": [6.6, 5.84, 8.03],
        "40-60": [5.68, 4.92, 6.93],
        "60-90": [5.34, 4.83, 5.86],
        "90-": [5.5, 4.86, 6.1],
      },
      mittel: {
        "-40": [6.86, 5.93, 7.5],
        "40-60": [5.83, 5.27, 6.55],
        "60-90": [5.66, 4.88, 6.51],
        "90-": [5.44, 4.91, 6.3],
      },
      gut: {
        "-40": [6.15, 5.52, 6.51],
        "40-60": [6.63, 5.66, 7.79],
        "60-90": [6.72, 5.49, 8.1],
        "90-": [6.09, 5.25, 7.5],
      },
    },
    "1950-1964": {
      einfach: {
        "-40": [5.53, 5.04, 6.09],
        "40-60": [5.43, 4.95, 5.91],
        "60-90": [5.09, 4.52, 6.07],
        "90-": [4.73, 4.35, 5.11],
      },
      mittel: {
        "-40": [6.2, 5.53, 7.0],
        "40-60": [5.6, 5.06, 6.5],
        "60-90": [5.54, 4.96, 6.53],
        "90-": [5.84, 5.6, 6.69],
      },
      gut: {
        "-40": [6.63, 5.0, 8.07],
        "40-60": [5.96, 5.0, 7.7],
        "60-90": [6.02, 5.12, 7.32],
        "90-": [7.06, 5.22, 10.0],
      },
    },
    "1965-1972": {
      einfach: {
        "-40": [6.12, 5.13, 7.27],
        "40-60": [5.13, 4.74, 5.75],
        "60-90": [4.7, 4.4, 5.24],
        "90-": [4.77, 4.28, 5.38],
      },
      mittel: {
        "-40": [6.27, 5.41, 7.01],
        "40-60": [5.43, 5.09, 5.86],
        "60-90": [5.21, 4.71, 5.67],
        "90-": [5.1, 4.56, 5.88],
      },
      gut: {
        "-40": [7.78, 6.32, 8.98],
        "40-60": [6.57, 4.83, 8.01],
        "60-90": [6.39, 5.54, 7.67],
        "90-": [7.82, 7.18, 8.93],
      },
    },
    "W:1973-1990": {
      einfach: {
        "-40": undefined,
        "40-60": [6.37, 5.79, 7.08],
        "60-90": [5.94, 5.47, 7.02],
        "90-": [5.57, 5.39, 6.44],
      },
      mittel: {
        "-40": undefined,
        "40-60": [6.97, 6.46, 7.84],
        "60-90": [7.14, 6.24, 8.27],
        "90-": [6.69, 5.71, 8.18],
      },
      gut: {
        "-40": undefined,
        "40-60": [7.59, 6.77, 8.21],
        "60-90": [7.88, 6.8, 8.55],
        "90-": [8.21, 7.33, 9.0],
      },
    },
    "O:1973-1990": {
      einfach: {
        "-40": [6.63, 6.02, 7.39],
        "40-60": [5.47, 5.11, 5.81],
        "60-90": [4.84, 4.46, 5.42],
        "90-": [4.54, 4.24, 5.02],
      },
      mittel: {
        "-40": [6.61, 6.29, 6.86],
        "40-60": [5.64, 5.37, 6.11],
        "60-90": [4.99, 4.75, 5.28],
        "90-": [4.94, 4.66, 5.22],
      },
      gut: {
        "-40": [7.88, 7.09, 8.66],
        "40-60": [6.41, 5.54, 6.99],
        "60-90": [5.66, 5.04, 6.16],
        "90-": [5.59, 5.01, 6.03],
      },
    },
    "1991-2002": {
      einfach: {
        "-40": undefined,
        "40-60": [7.45, 6.62, 8.34],
        "60-90": [6.99, 5.76, 8.27],
        "90-": [7.28, 6.12, 8.01],
      },
      mittel: {
        "-40": undefined,
        "40-60": [7.34, 6.32, 8.36],
        "60-90": [6.92, 5.19, 7.97],
        "90-": [7.45, 6.5, 8.98],
      },
      gut: {
        "-40": [7.83, 7.35, 8.52],
        "40-60": [8.52, 7.25, 9.55],
        "60-90": [8.5, 7.12, 9.64],
        "90-": [9.04, 7.19, 10.71],
      },
    },
    "2003-2013": {
      einfach: {
        "-40": undefined,
        "40-60": undefined,
        "60-90": [9.36, 7.92, 10.66],
        "90-": [10.88, 9.5, 13.0],
      },
      mittel: {
        "-40": undefined,
        "40-60": [10.01, 7.69, 12.31],
        "60-90": [8.79, 7.5, 10.69],
        "90-": [9.79, 8.0, 12.35],
      },
      gut: {
        "-40": undefined,
        "40-60": [8.62, 8.03, 9.37],
        "60-90": [8.63, 8.0, 9.68],
        "90-": [9.14, 8.11, 11.24],
      },
    },
  },
  "2017": {
    "-1918": {
      einfach: {
        "-40": [7.45, 5.44, 10.0],
        "40-60": [6.51, 4.81, 9.22],
        "60-90": [6.0, 4.4, 8.62],
        "90-": [5.72, 4.22, 8.41],
      },
      mittel: {
        "-40": [8.01, 5.25, 10.11],
        "40-60": [6.61, 5.11, 10.06],
        "60-90": [6.78, 4.75, 10.27],
        "90-": [6.39, 4.38, 10.18],
      },
      gut: {
        "-40": [8.31, 6.91, 12.52],
        "40-60": [7.03, 5.81, 8.75],
        "60-90": [7.32, 5.81, 10.0],
        "90-": [7.25, 5.44, 10.0],
      },
    },
    "1919-1949": {
      einfach: {
        "-40": [6.45, 5.6, 7.17],
        "40-60": [5.93, 5.3, 8.09],
        "60-90": [5.65, 4.9, 7.56],
        "90-": [5.8, 4.29, 7.51],
      },
      mittel: {
        "-40": [7.37, 6.82, 8.4],
        "40-60": [6.34, 5.52, 7.65],
        "60-90": [6.09, 5.18, 7.62],
        "90-": [5.63, 4.97, 7.1],
      },
      gut: {
        "-40": [7.04, 6.04, 10.0],
        "40-60": [6.88, 5.71, 8.88],
        "60-90": [7.1, 5.52, 9.2],
        "90-": [6.65, 5.35, 9.5],
      },
    },
    "1950-1964": {
      einfach: {
        "-40": [6.17, 5.18, 8.8],
        "40-60": [5.71, 5.16, 7.29],
        "60-90": [5.48, 4.74, 6.68],
        "90-": [4.87, 4.29, 6.6],
      },
      mittel: {
        "-40": [6.64, 5.89, 8.0],
        "40-60": [6.11, 5.43, 7.48],
        "60-90": [6.0, 5.18, 7.28],
        "90-": [6.46, 5.77, 8.03],
      },
      gut: {
        "-40": [7.48, 5.87, 10.2],
        "40-60": [6.66, 5.18, 8.98],
        "60-90": [6.81, 5.58, 8.82],
        "90-": [8.26, 6.77, 9.61],
      },
    },
    "1965-1972": {
      einfach: {
        "-40": [6.58, 5.78, 7.74],
        "40-60": [5.75, 5.13, 7.01],
        "60-90": [5.22, 4.76, 6.3],
        "90-": [5.29, 4.8, 6.14],
      },
      mittel: {
        "-40": [6.57, 5.71, 8.36],
        "40-60": [5.72, 5.39, 7.2],
        "60-90": [5.49, 5.05, 6.59],
        "90-": [5.53, 4.91, 7.5],
      },
      gut: {
        "-40": [8.83, 7.7, 9.84],
        "40-60": [7.39, 6.17, 9.0],
        "60-90": [6.9, 6.09, 8.59],
        "90-": [8.05, 6.99, 8.54],
      },
    },
    "W:1973-1990": {
      einfach: {
        "-40": [7.68, 5.33, 8.15],
        "40-60": [6.77, 5.8, 8.43],
        "60-90": [6.12, 5.08, 7.59],
        "90-": [6.49, 5.39, 8.05],
      },
      mittel: {
        "-40": [8.08, 7.18, 12.0],
        "40-60": [7.39, 6.65, 7.97],
        "60-90": [7.5, 6.16, 8.76],
        "90-": [7.48, 5.17, 8.8],
      },
      gut: {
        "-40": [8.59, 6.93, 10.11],
        "40-60": [8.0, 7.3, 9.12],
        "60-90": [8.24, 7.07, 9.69],
        "90-": [8.83, 7.6, 10.49],
      },
    },
    "O:1973-1990": {
      einfach: {
        "-40": [6.81, 6.13, 7.63],
        "40-60": [5.61, 5.3, 6.67],
        "60-90": [5.07, 4.72, 5.71],
        "90-": [4.7, 4.24, 5.6],
      },
      mittel: {
        "-40": [6.77, 6.4, 7.94],
        "40-60": [5.83, 5.37, 6.75],
        "60-90": [5.11, 4.68, 5.78],
        "90-": [5.11, 4.76, 5.6],
      },
      gut: {
        "-40": [8.04, 7.09, 9.14],
        "40-60": [6.84, 6.11, 8.29],
        "60-90": [6.0, 5.37, 7.0],
        "90-": [5.63, 5.24, 6.92],
      },
    },
    "1991-2002": {
      einfach: {
        "-40": undefined,
        "40-60": [7.43, 6.21, 9.17],
        "60-90": [7.1, 5.76, 8.23],
        "90-": [7.18, 5.95, 8.47],
      },
      mittel: {
        "-40": undefined,
        "40-60": [8.18, 6.84, 9.37],
        "60-90": [7.59, 6.52, 8.96],
        "90-": [8.0, 6.3, 9.27],
      },
      gut: {
        "-40": undefined,
        "40-60": [9.0, 7.48, 10.34],
        "60-90": [8.77, 7.31, 10.54],
        "90-": [9.24, 7.18, 11.13],
      },
    },
    "2003-2015": {
      einfach: {
        "-40": [7.5, 7.5, 9.51],
        "40-60": [8.5, 6.9, 12.5],
        "60-90": [10.13, 6.9, 12.99],
        "90-": [10.7, 8.6, 13.56],
      },
      mittel: {
        "-40": [14.19, 13.85, 15.72],
        "40-60": [10.1, 8.4, 13.94],
        "60-90": [10.31, 8.61, 13.93],
        "90-": [10.19, 8.69, 13.1],
      },
      gut: {
        "-40": undefined,
        "40-60": [9.44, 8.0, 11.3],
        "60-90": [9.01, 8.44, 11.07],
        "90-": [10.0, 8.4, 12.5],
      },
    },
  },
  "2019": {
    "-1918": {
      einfach: {
        "-40": [7.9, 5.5, 12.97],
        "40-60": [6.75, 5.26, 9.94],
        "60-90": [6.33, 4.83, 10.0],
        "90-": [6.23, 4.79, 9.14],
      },
      mittel: {
        "-40": [8.43, 6.72, 12.24],
        "40-60": [7.43, 5.41, 10.25],
        "60-90": [6.77, 4.84, 10.0],
        "90-": [6.77, 4.88, 9.8],
      },
      gut: {
        "-40": [11.44, 6.54, 14.23],
        "40-60": [8.04, 5.99, 10.97],
        "60-90": [7.49, 5.62, 10.92],
        "90-": [7.33, 5.48, 10.48],
      },
    },
    "1919-1949": {
      einfach: {
        "-40": [7.8, 6.0, 8.68],
        "40-60": [6.4, 5.42, 8.19],
        "60-90": [5.87, 5.06, 7.27],
        "90-": [6.13, 5.14, 7.16],
      },
      mittel: {
        "-40": [7.66, 6.44, 8.55],
        "40-60": [6.74, 5.63, 7.76],
        "60-90": [6.24, 5.09, 7.32],
        "90-": [6.01, 5.1, 8.51],
      },
      gut: {
        "-40": [7.5, 6.44, 9.48],
        "40-60": [6.9, 6.01, 9.14],
        "60-90": [7.1, 5.91, 9.15],
        "90-": [6.69, 5.69, 8.93],
      },
    },
    "1950-1964": {
      einfach: {
        "-40": [6.43, 5.54, 9.03],
        "40-60": [6.0, 5.38, 8.0],
        "60-90": [5.58, 4.83, 6.81],
        "90-": undefined,
      },
      mittel: {
        "-40": [6.85, 5.65, 9.05],
        "40-60": [6.11, 5.39, 7.64],
        "60-90": [6.0, 5.28, 7.08],
        "90-": [6.77, 5.62, 11.41],
      },
      gut: {
        "-40": [7.47, 6.36, 9.31],
        "40-60": [6.52, 5.65, 7.85],
        "60-90": [6.54, 5.5, 8.37],
        "90-": [8.23, 6.69, 9.3],
      },
    },
    "1965-1972": {
      einfach: {
        "-40": [6.8, 5.99, 8.83],
        "40-60": [5.88, 5.05, 7.01],
        "60-90": [5.45, 4.89, 6.08],
        "90-": [5.47, 4.89, 6.05],
      },
      mittel: {
        "-40": [6.57, 5.89, 8.24],
        "40-60": [5.98, 5.43, 6.94],
        "60-90": [5.71, 5.08, 6.4],
        "90-": [5.4, 5.06, 6.14],
      },
      gut: {
        "-40": [8.9, 8.15, 9.75],
        "40-60": [7.13, 5.29, 10.0],
        "60-90": [6.65, 5.2, 8.31],
        "90-": [8.3, 7.54, 8.89],
      },
    },
    "W:1973-1990": {
      einfach: {
        "-40": [7.57, 7.43, 8.85],
        "40-60": [7.46, 6.2, 8.65],
        "60-90": [7.27, 6.08, 9.0],
        "90-": [7.19, 5.83, 8.28],
      },
      mittel: {
        "-40": [7.73, 5.33, 8.16],
        "40-60": [7.73, 6.36, 8.77],
        "60-90": [8.0, 5.7, 9.11],
        "90-": [7.64, 5.97, 8.66],
      },
      gut: {
        "-40": [8.31, 7.47, 10.09],
        "40-60": [8.42, 7.38, 9.22],
        "60-90": [8.32, 6.61, 9.84],
        "90-": [9.0, 7.06, 11.94],
      },
    },
    "O:1973-1990": {
      einfach: {
        "-40": [7.14, 6.85, 7.97],
        "40-60": [6.01, 5.72, 6.55],
        "60-90": [5.27, 4.99, 5.73],
        "90-": [5.23, 4.78, 5.48],
      },
      mittel: {
        "-40": [6.93, 6.45, 7.23],
        "40-60": [5.95, 5.4, 6.7],
        "60-90": [5.27, 4.6, 5.76],
        "90-": [5.25, 4.61, 5.56],
      },
      gut: {
        "-40": [7.13, 6.7, 8.73],
        "40-60": [6.01, 5.83, 6.96],
        "60-90": [5.57, 5.11, 6.29],
        "90-": [5.32, 5.08, 5.93],
      },
    },
    "1991-2002": {
      einfach: {
        "-40": undefined,
        "40-60": [8.36, 7.71, 10.2],
        "60-90": [7.72, 6.23, 8.59],
        "90-": [7.96, 6.64, 9.32],
      },
      mittel: {
        "-40": undefined,
        "40-60": [8.18, 7.43, 9.17],
        "60-90": [7.9, 6.73, 9.03],
        "90-": [8.19, 7.21, 9.54],
      },
      gut: {
        "-40": undefined,
        "40-60": [9.75, 8.14, 11.12],
        "60-90": [9.09, 7.45, 11.02],
        "90-": [9.8, 8.17, 11.7],
      },
    },
    "2003-2017": {
      einfach: {
        "-40": undefined,
        "40-60": [11.61, 9.7, 15.11],
        "60-90": [12.89, 8.49, 14.83],
        "90-": [11.95, 8.52, 13.77],
      },
      mittel: {
        "-40": undefined,
        "40-60": [9.85, 7.28, 12.5],
        "60-90": [10.09, 8.91, 12.2],
        "90-": [10.08, 8.8, 12.73],
      },
      gut: {
        "-40": undefined,
        "40-60": [9.88, 7.75, 11.98],
        "60-90": [10.22, 8.84, 12.75],
        "90-": [11.5, 9.34, 13.69],
      },
    },
  },
  "2021": {
    "-1918": {
      einfach: {
        "-40": [7.99, 5.56, 13.11],
        "40-60": [6.82, 5.32, 10.05],
        "60-90": [6.4, 4.88, 10.11],
        "90-": [6.3, 4.84, 9.24],
      },
      mittel: {
        "-40": [8.52, 6.79, 12.37],
        "40-60": [7.51, 5.47, 10.36],
        "60-90": [6.84, 4.89, 10.11],
        "90-": [6.84, 4.93, 9.91],
      },
      gut: {
        "-40": [11.57, 6.61, 14.39],
        "40-60": [8.13, 6.06, 11.09],
        "60-90": [7.57, 5.68, 11.04],
        "90-": [7.41, 5.54, 10.6],
      },
    },
    "1919-1949": {
      einfach: {
        "-40": [7.89, 6.07, 8.78],
        "40-60": [6.47, 5.48, 8.28],
        "60-90": [5.93, 5.12, 7.35],
        "90-": [6.2, 5.2, 7.24],
      },
      mittel: {
        "-40": [7.74, 6.51, 8.64],
        "40-60": [6.81, 5.69, 7.85],
        "60-90": [6.31, 5.15, 7.4],
        "90-": [6.08, 5.16, 8.6],
      },
      gut: {
        "-40": [7.58, 6.51, 9.58],
        "40-60": [6.98, 6.08, 9.24],
        "60-90": [7.18, 5.98, 9.25],
        "90-": [6.76, 5.75, 9.03],
      },
    },
    "1950-1964": {
      einfach: {
        "-40": [6.5, 5.6, 9.13],
        "40-60": [6.07, 5.44, 8.09],
        "60-90": [5.64, 4.88, 6.88],
        "90-": undefined,
      },
      mittel: {
        "-40": [6.93, 5.71, 9.15],
        "40-60": [6.18, 5.45, 7.72],
        "60-90": [6.07, 5.34, 7.16],
        "90-": [6.84, 5.68, 11.54],
      },
      gut: {
        "-40": [7.55, 6.43, 9.41],
        "40-60": [6.59, 5.71, 7.94],
        "60-90": [6.61, 5.56, 8.46],
        "90-": [8.32, 6.76, 9.4],
      },
    },
    "1965-1972": {
      einfach: {
        "-40": [6.87, 6.06, 8.93],
        "40-60": [5.94, 5.11, 7.09],
        "60-90": [5.51, 4.94, 6.15],
        "90-": [5.53, 4.94, 6.12],
      },
      mittel: {
        "-40": [6.64, 5.95, 8.33],
        "40-60": [6.05, 5.49, 7.02],
        "60-90": [5.77, 5.14, 6.47],
        "90-": [5.46, 5.12, 6.21],
      },
      gut: {
        "-40": [9.0, 8.24, 9.86],
        "40-60": [7.21, 5.35, 10.11],
        "60-90": [6.72, 5.26, 8.4],
        "90-": [8.39, 7.62, 8.99],
      },
    },
    "W:1973-1990": {
      einfach: {
        "-40": [7.65, 7.51, 8.95],
        "40-60": [7.54, 6.27, 8.75],
        "60-90": [7.35, 6.15, 9.1],
        "90-": [7.27, 5.89, 8.37],
      },
      mittel: {
        "-40": [7.82, 5.39, 8.25],
        "40-60": [7.82, 6.43, 8.87],
        "60-90": [8.09, 5.76, 9.21],
        "90-": [7.72, 6.04, 8.76],
      },
      gut: {
        "-40": [8.4, 7.55, 10.2],
        "40-60": [8.51, 7.46, 9.32],
        "60-90": [8.41, 6.68, 9.95],
        "90-": [9.1, 7.14, 12.07],
      },
    },
    "O:1973-1990": {
      einfach: {
        "-40": [7.22, 6.93, 8.06],
        "40-60": [6.08, 5.78, 6.62],
        "60-90": [5.33, 5.04, 5.79],
        "90-": [5.29, 4.83, 5.54],
      },
      mittel: {
        "-40": [7.01, 6.52, 7.31],
        "40-60": [6.02, 5.46, 6.77],
        "60-90": [5.33, 4.65, 5.82],
        "90-": [5.31, 4.66, 5.62],
      },
      gut: {
        "-40": [7.21, 6.77, 8.83],
        "40-60": [6.08, 5.89, 7.04],
        "60-90": [5.63, 5.17, 6.36],
        "90-": [5.38, 5.14, 6.0],
      },
    },
    "1991-2002": {
      einfach: {
        "-40": undefined,
        "40-60": [8.45, 7.79, 10.31],
        "60-90": [7.8, 6.3, 8.68],
        "90-": [8.05, 6.71, 9.42],
      },
      mittel: {
        "-40": undefined,
        "40-60": [8.27, 7.51, 9.27],
        "60-90": [7.99, 6.8, 9.13],
        "90-": [8.28, 7.29, 9.64],
      },
      gut: {
        "-40": undefined,
        "40-60": [9.86, 8.23, 11.24],
        "60-90": [9.19, 7.53, 11.14],
        "90-": [9.91, 8.26, 11.83],
      },
    },
    "2003-2017": {
      einfach: {
        "-40": undefined,
        "40-60": [11.74, 9.81, 15.28],
        "60-90": [13.03, 8.58, 14.99],
        "90-": [12.08, 8.61, 13.92],
      },
      mittel: {
        "-40": undefined,
        "40-60": [9.96, 7.36, 12.64],
        "60-90": [10.2, 9.01, 12.33],
        "90-": [10.19, 8.9, 12.87],
      },
      gut: {
        "-40": undefined,
        "40-60": [9.99, 7.84, 12.11],
        "60-90": [10.33, 8.94, 12.89],
        "90-": [11.63, 9.44, 13.84],
      },
    },
  },
  "2023": {
    "-1918": {
      einfach: {
        "-40": [8.42, 5.86, 13.82],
        "40-60": [7.19, 5.61, 10.59],
        "60-90": [6.75, 5.14, 10.66],
        "90-": [6.64, 5.1, 9.74],
      },
      mittel: {
        "-40": [8.98, 7.16, 13.04],
        "40-60": [7.92, 5.77, 10.92],
        "60-90": [7.21, 5.15, 10.66],
        "90-": [7.21, 5.2, 10.45],
      },
      gut: {
        "-40": [12.19, 6.97, 15.17],
        "40-60": [8.57, 6.39, 11.69],
        "60-90": [7.98, 5.99, 11.64],
        "90-": [7.81, 5.84, 11.17],
      },
    },
    "1919-1949": {
      einfach: {
        "-40": [8.32, 6.4, 9.25],
        "40-60": [6.82, 5.78, 8.73],
        "60-90": [6.25, 5.4, 7.75],
        "90-": [6.53, 5.48, 7.63],
      },
      mittel: {
        "-40": [8.16, 6.86, 9.11],
        "40-60": [7.18, 6.0, 8.27],
        "60-90": [6.65, 5.43, 7.8],
        "90-": [6.41, 5.44, 9.06],
      },
      gut: {
        "-40": [7.99, 6.86, 10.1],
        "40-60": [7.36, 6.41, 9.74],
        "60-90": [7.57, 6.3, 9.75],
        "90-": [7.13, 6.06, 9.52],
      },
    },
    "1950-1964": {
      einfach: {
        "-40": [6.85, 5.9, 9.62],
        "40-60": [6.4, 5.73, 8.53],
        "60-90": [5.94, 5.14, 7.25],
        "90-": undefined,
      },
      mittel: {
        "-40": [7.3, 6.02, 9.64],
        "40-60": [6.51, 5.74, 8.14],
        "60-90": [6.4, 5.63, 7.55],
        "90-": [7.21, 5.99, 12.16],
      },
      gut: {
        "-40": [7.96, 6.78, 9.92],
        "40-60": [6.95, 6.02, 8.37],
        "60-90": [6.97, 5.86, 8.92],
        "90-": [8.77, 7.13, 9.91],
      },
    },
    "1965-1972": {
      einfach: {
        "-40": [7.24, 6.39, 9.41],
        "40-60": [6.26, 5.39, 7.47],
        "60-90": [5.81, 5.21, 6.48],
        "90-": [5.83, 5.21, 6.45],
      },
      mittel: {
        "-40": [7, 6.27, 8.78],
        "40-60": [6.38, 5.79, 7.4],
        "60-90": [6.08, 5.42, 6.82],
        "90-": [5.75, 5.4, 6.55],
      },
      gut: {
        "-40": [9.49, 8.68, 10.39],
        "40-60": [7.6, 5.64, 10.66],
        "60-90": [7.08, 5.54, 8.85],
        "90-": [8.84, 8.03, 9.48],
      },
    },
    "W:1973-1990": {
      einfach: {
        "-40": [8.06, 7.92, 9.43],
        "40-60": [7.95, 6.61, 9.22],
        "60-90": [7.75, 6.48, 9.59],
        "90-": [7.66, 6.21, 8.82],
      },
      mittel: {
        "-40": [8.24, 5.68, 8.7],
        "40-60": [8.24, 6.78, 9.35],
        "60-90": [8.53, 6.07, 9.71],
        "90-": [8.14, 6.37, 9.23],
      },
      gut: {
        "-40": [8.85, 7.96, 10.75],
        "40-60": [8.97, 7.86, 9.82],
        "60-90": [8.86, 7.04, 10.49],
        "90-": [9.59, 7.53, 12.72],
      },
    },
    "O:1973-1990": {
      einfach: {
        "-40": [7.61, 7.3, 8.5],
        "40-60": [6.41, 6.09, 6.98],
        "60-90": [5.62, 5.31, 6.1],
        "90-": [5.58, 5.09, 5.84],
      },
      mittel: {
        "-40": [7.39, 6.87, 7.7],
        "40-60": [6.35, 5.75, 7.14],
        "60-90": [5.62, 4.9, 6.13],
        "90-": [5.6, 4.91, 5.92],
      },
      gut: {
        "-40": [7.6, 7.14, 9.31],
        "40-60": [6.41, 6.21, 7.42],
        "60-90": [5.93, 5.45, 6.7],
        "90-": [5.67, 5.42, 6.32],
      },
    },
    "1991-2002": {
      einfach: {
        "-40": undefined,
        "40-60": [8.91, 8.21, 10.87],
        "60-90": [8.22, 6.64, 9.15],
        "90-": [8.48, 7.07, 9.93],
      },
      mittel: {
        "-40": undefined,
        "40-60": [8.72, 7.92, 9.77],
        "60-90": [8.42, 7.17, 9.62],
        "90-": [8.73, 7.68, 10.16],
      },
      gut: {
        "-40": undefined,
        "40-60": [10.39, 8.67, 11.85],
        "60-90": [9.69, 7.94, 11.74],
        "90-": [10.45, 8.71, 12.47],
      },
    },
    "2003-2017": {
      einfach: {
        "-40": undefined,
        "40-60": [12.37, 10.34, 16.11],
        "60-90": [13.73, 9.04, 15.8],
        "90-": [12.73, 9.07, 14.67],
      },
      mittel: {
        "-40": undefined,
        "40-60": [10.5, 7.76, 13.32],
        "60-90": [10.75, 9.5, 13],
        "90-": [10.74, 9.38, 13.56],
      },
      gut: {
        "-40": undefined,
        "40-60": [10.53, 8.26, 12.76],
        "60-90": [10.89, 9.42, 13.59],
        "90-": [12.26, 9.95, 14.59],
      },
    },
  },
  "2024": {
    "-1918": {
      einfach: {
        "-35": [9.87, 7.19, 14.19],
        "35-40": [9.08, 6.83, 13.08],
        "40-45": [8.52, 6.15, 12.54],
        "45-55": [8.02, 6.1, 11.19],
        "55-60": [8.42, 6.07, 11.0],
        "60-90": [6.96, 5.29, 10.39],
        "90-105": [6.33, 4.93, 9.97],
        "105-": [6.61, 5.34, 9.02],
      },
      mittel: {
        "-35": [10.12, 7.68, 12.76],
        "35-40": [8.98, 7.05, 13.75],
        "40-45": [9.37, 6.81, 12.64],
        "45-50": [7.48, 6.33, 12.63],
        "50-55": [7.45, 5.85, 10.26],
        "55-80": [7.91, 5.79, 11.5],
        "80-120": [7.57, 5.74, 11.05],
        "120-130": [7.25, 5.44, 11.09],
        "130-": [6.98, 5.03, 10.57],
      },
      gut: {
        "-35": [10.65, 7.39, 15.32],
        "35-40": [11.09, 6.85, 15.31],
        "40-45": [9.2, 6.26, 13.46],
        "45-65": [8.8, 6.52, 12.78],
        "65-115": [8.45, 6.09, 12.55],
        "115-": [8.13, 6.14, 11.97],
      },
    },
    "1919-1949": {
      einfach: {
        "-40": [7.96, 6.5, 10.74],
        "40-60": [7.03, 5.99, 9.35],
        "60-90": [6.54, 5.55, 8.82],
        "90-105": [6.33, 4.93, 9.97],
        "105-": [6.61, 5.34, 9.02],
      },
      mittel: {
        "-35": [7.94, 6.11, 11.49],
        "35-40": [7.53, 6.25, 9.56],
        "40-45": [7.4, 6.44, 8.8],
        "45-50": [7.42, 6.26, 9.28],
        "50-65": [7.12, 6.02, 9.19],
        "65-75": [6.65, 5.69, 8.41],
        "75-": [6.96, 5.79, 10.0],
      },
      gut: {
        "-35": [9.45, 7.03, 14.21],
        "35-40": [8.5, 6.84, 11.45],
        "40-65": [8.24, 6.47, 11.16],
        "65-": [7.46, 6.05, 10.36],
      },
    },
    "1950-1964": {
      einfach: {
        "-40": [7.96, 6.5, 10.74],
        "40-60": [7.03, 5.99, 9.35],
        "60-": [6.2, 5.23, 8.0],
      },
      mittel: {
        "-35": [7.94, 6.11, 11.49],
        "35-40": [7.53, 6.25, 9.56],
        "40-45": [7.07, 5.88, 9.06],
        "45-": [6.6, 5.73, 8.86],
      },
      gut: {
        "-35": [9.45, 7.03, 14.21],
        "35-40": [8.5, 6.84, 11.45],
        "40-90": [7.14, 5.82, 10.13],
        "90-": [8.99, 6.32, 11.58],
      },
    },
    "1965-1972": {
      einfach: {
        "-55": [6.76, 5.68, 8.58],
        "55-60": [6.1, 5.37, 7.72],
        "60-": [5.87, 5.22, 7.18],
      },
      mittel: {
        "-35": [7.36, 6.57, 14.03],
        "35-40": [7.21, 6.45, 9.73],
        "40-45": [7.07, 5.88, 9.06],
        "45-": [6.13, 5.36, 8.41],
      },
      gut: {
        "-35": [9.45, 7.03, 14.21],
        "35-40": [8.5, 6.84, 11.45],
        "40-90": [7.14, 5.82, 10.13],
        "90-": [8.99, 6.32, 11.58],
      },
    },
    "W:1973-1985": {
      einfach: {
        "-55": [6.76, 5.68, 8.58],
        "55-60": [6.1, 5.37, 7.72],
        "60-90": [6.54, 5.77, 8.51],
        "90-": [7.35, 5.24, 9.08],
      },
      mittel: {
        "-35": [7.36, 6.57, 14.03],
        "35-40": [7.21, 6.45, 9.73],
        "40-45": [7.07, 5.88, 9.06],
        "45-75": [8.18, 6.32, 10.64],
        "75-": [7.85, 6.44, 10.1],
      },
      gut: {
        "-75": [9.42, 7.27, 11.98],
        "75-85": [9.25, 7.51, 11.79],
        "85-105": [9.79, 7.94, 13.32],
        "105-120": [10.65, 8.55, 13.41],
        "120-": [10.08, 6.95, 13.02],
      },
    },
    "W:1986-1990": {
      einfach: {
        "-55": [8.19, 6.47, 10.49],
        "55-60": [8.56, 6.48, 11.14],
        "60-75": [7.92, 6.27, 9.59],
        "75-80": [8.13, 6.89, 9.28],
        "80-95": [8.06, 6.67, 9.99],
        "95-": [8.38, 6.59, 9.96],
      },
      mittel: {
        "-50": [9.26, 8.0, 12.34],
        "50-55": [8.87, 7.17, 10.69],
        "55-60": [9.27, 8.0, 11.05],
        "60-70": [9.11, 7.87, 11.46],
        "70-75": [8.57, 6.89, 9.98],
        "75-85": [8.86, 7.52, 10.04],
        "85-90": [8.68, 6.55, 10.43],
        "90-100": [8.99, 6.24, 9.94],
        "100-": [9.12, 7.21, 11.28],
      },
      gut: {
        "-75": [10.15, 8.35, 12.91],
        "75-85": [9.25, 7.51, 11.79],
        "85-105": [9.79, 7.94, 13.32],
        "105-120": [10.65, 8.55, 13.41],
        "120-": [10.08, 6.95, 13.02],
      },
    },
    "O:1973-1990": {
      einfach: {
        "-40": [7.16, 6.66, 8.89],
        "40-60": [6.25, 5.74, 7.28],
        "60-70": [5.37, 5.07, 6.06],
        "70-": [5.44, 5.03, 6.11],
      },
      mittel: {
        "-40": [7.13, 6.41, 8.6],
        "40-60": [6.09, 5.59, 6.82],
        "60-65": [5.37, 4.99, 6.44],
        "65-": [5.43, 4.95, 6.35],
      },
      gut: {
        "-45": [6.97, 6.11, 8.48],
        "45-60": [6.46, 5.83, 8.54],
        "60-75": [5.68, 5.16, 8.51],
        "75-": [5.72, 5.08, 6.47],
      },
    },
    "1991-2001": {
      einfach: {
        "-55": [8.19, 6.47, 10.49],
        "55-60": [8.56, 6.48, 11.14],
        "60-75": [7.92, 6.27, 9.59],
        "75-80": [8.13, 6.89, 9.28],
        "80-95": [8.06, 6.67, 9.99],
        "95-": [8.38, 6.59, 9.96],
      },
      mittel: {
        "-50": [9.26, 8.0, 12.34],
        "50-55": [8.87, 7.17, 10.69],
        "55-60": [9.27, 8.0, 11.05],
        "60-70": [9.11, 7.87, 11.46],
        "70-75": [8.57, 6.89, 9.98],
        "75-85": [8.86, 7.52, 10.04],
        "85-90": [8.68, 6.55, 10.43],
        "90-100": [8.99, 6.24, 9.94],
        "100-": [9.12, 7.21, 11.28],
      },
      gut: {
        "-75": [10.15, 8.35, 12.91],
        "75-85": [9.25, 7.51, 11.79],
        "85-105": [9.79, 7.94, 13.32],
        "105-120": [10.65, 8.55, 13.41],
        "120-": [10.08, 6.95, 13.02],
      },
    },
    "2002-2009": {
      einfach: {
        "-55": [8.19, 6.47, 10.49],
        "55-60": [8.56, 6.48, 11.14],
        "60-75": [7.92, 6.27, 9.59],
        "75-80": [8.13, 6.89, 9.28],
        "80-95": [8.06, 6.67, 9.99],
        "95-": [8.38, 6.59, 9.96],
      },
      mittel: {
        "-50": [9.26, 8.0, 12.34],
        "50-55": [8.87, 7.17, 10.69],
        "55-60": [9.27, 8.0, 11.05],
        "60-70": [9.11, 7.87, 11.46],
        "70-75": [8.57, 6.89, 9.98],
        "75-85": [8.86, 7.52, 10.04],
        "85-90": [8.68, 6.55, 10.43],
        "90-100": [8.99, 6.24, 9.94],
        "100-": [9.12, 7.21, 11.28],
      },
      gut: {
        "-105": [11.04, 7.97, 15.5],
        "105-": [12.12, 9.58, 15.34],
      },
    },
    "2010-2015": {
      einfach: {
        "0-": [9.98, 7.24, 14.48],
      },
      mittel: {
        "-70": [10.76, 8.18, 16.75],
        "70-95": [12.05, 8.92, 16.11],
        "95-": [12.77, 9.2, 15.19],
      },
      gut: {
        "-85": [13.79, 10.24, 17.56],
        "85-": [14.4, 11.89, 17.34],
      },
    },
    "2016-2022": {
      einfach: {
        "-60": [12.41, 7.62, 16.66],
        "60-80": [11.12, 9.0, 17.43],
        "80-": [12.48, 9.99, 16.55],
      },
      mittel: {
        "-55": [14.44, 10.22, 21.93],
        "55-65": [12.97, 10.07, 19.24],
        "65-75": [12.1, 9.77, 17.75],
        "75-90": [13.82, 10.06, 18.55],
        "90-": [14.41, 10.07, 18.04],
      },
      gut: {
        "-50": [17.72, 11.41, 24.74],
        "50-65": [16.8, 10.5, 23.84],
        "65-85": [15.58, 11.21, 19.93],
        "85-100": [17.51, 13.69, 20.74],
        "100-": [16.07, 12.22, 18.47],
      },
    },
  },
  "2026": {
    "-1918": {
      einfach: {
        "-35": [9.58, 6.53, 13.43],
        "35-40": [10.04, 7.06, 14.21],
        "40-45": [9.27, 7.01, 12.25],
        "45-50": [8.01, 6.8, 10.75],
        "50-55": [8.01, 6.13, 11.33],
        "55-60": [8.42, 6.45, 11.93],
        "60-65": [8.27, 5.91, 11.85],
        "65-70": [8.14, 5.91, 12.21],
        "70-75": [8.46, 6.24, 11.65],
        "75-85": [7.56, 5.91, 10.76],
        "85-120": [7.19, 5.52, 10.99],
        "120-": [6.48, 5.38, 11.24],
      },
      mittel: {
        "-35": [11.05, 8.07, 14.35],
        "35-40": [11.06, 8.44, 15.13],
        "40-65": [8.49, 6.46, 12.59],
        "65-70": [9.0, 6.45, 11.7],
        "70-80": [7.9, 6.09, 11.7],
        "80-90": [8.27, 6.66, 11.73],
        "90-100": [7.65, 5.95, 11.52],
        "100-105": [7.87, 5.95, 12.63],
        "105-120": [7.29, 5.48, 11.43],
        "120-": [7.56, 5.75, 11.21],
      },
      gut: {
        "-35": [11.75, 7.62, 16.43],
        "35-40": [11.67, 8.57, 14.92],
        "40-45": [9.54, 7.2, 14.4],
        "45-50": [9.64, 6.7, 13.32],
        "50-60": [9.03, 6.89, 13.16],
        "60-70": [9.46, 7.09, 13.54],
        "70-80": [8.97, 6.25, 13.66],
        "80-90": [8.8, 6.75, 12.17],
        "90-110": [8.45, 6.6, 12.99],
        "110-": [8.84, 6.3, 13.24],
      },
    },
    "1919-1949": {
      einfach: {
        "-40": [8.58, 7.25, 10.43],
        "40-50": [7.82, 6.57, 10.01],
        "50-60": [7.6, 6.29, 9.63],
        "60-": [6.99, 5.78, 9.12],
      },
      mittel: {
        "-40": [8.83, 7.74, 10.51],
        "40-45": [8.28, 7.03, 10.38],
        "45-60": [7.73, 6.32, 9.8],
        "60-": [7.3, 5.9, 9.55],
      },
      gut: {
        "-35": [9.47, 7.19, 14.79],
        "35-40": [9.07, 7.4, 11.42],
        "40-45": [8.54, 6.8, 11.1],
        "45-65": [8.82, 6.84, 11.74],
        "65-": [8.11, 6.37, 11.93],
      },
    },
    "1950-1964": {
      einfach: {
        "-35": [8.07, 6.64, 10.23],
        "35-40": [7.72, 6.61, 9.97],
        "40-55": [7.32, 6.23, 9.53],
        "55-60": [6.99, 6.01, 8.89],
        "60-": [6.63, 5.77, 8.0],
      },
      mittel: {
        "-35": [8.54, 6.55, 10.62],
        "35-40": [7.78, 6.6, 10.49],
        "40-45": [7.72, 6.7, 10.01],
        "45-": [7.08, 5.9, 9.25],
      },
      gut: {
        "-35": [9.47, 7.19, 14.79],
        "35-40": [9.07, 7.4, 11.42],
        "40-45": [8.54, 6.8, 11.1],
        "45-90": [7.56, 6.07, 10.92],
        "90-": [10.0, 7.49, 12.78],
      },
    },
    "1965-1972": {
      einfach: {
        "-35": [8.07, 6.64, 10.23],
        "35-40": [7.72, 6.61, 9.97],
        "40-55": [7.32, 6.23, 9.53],
        "55-60": [6.99, 6.01, 8.89],
        "60-85": [6.35, 5.54, 7.55],
        "85-": [6.05, 5.45, 6.97],
      },
      mittel: {
        "-35": [8.1, 6.8, 13.01],
        "35-40": [7.78, 6.6, 10.49],
        "40-45": [7.72, 6.7, 10.01],
        "45-": [6.65, 5.77, 8.74],
      },
      gut: {
        "-35": [9.47, 7.19, 14.79],
        "35-40": [9.07, 7.4, 11.42],
        "40-45": [8.54, 6.8, 11.1],
        "45-90": [7.56, 6.07, 10.92],
        "90-": [10.0, 7.49, 12.78],
      },
    },
    "W:1973-1985": {
      einfach: {
        "-35": [8.07, 6.64, 10.23],
        "35-40": [7.72, 6.61, 9.97],
        "40-55": [7.32, 6.23, 9.53],
        "55-60": [6.99, 6.01, 8.89],
        "60-70": [7.03, 6.19, 9.3],
        "70-90": [7.26, 6.18, 8.43],
        "90-": [6.86, 5.72, 8.76],
      },
      mittel: {
        "-35": [8.1, 6.8, 13.01],
        "35-40": [7.78, 6.6, 10.49],
        "40-45": [7.72, 6.7, 10.01],
        "45-70": [8.21, 7.18, 9.76],
        "70-85": [8.09, 6.65, 10.3],
        "85-": [8.35, 6.79, 10.7],
      },
      gut: {
        "-50": [9.06, 6.96, 11.98],
        "50-85": [9.42, 7.12, 12.41],
        "85-": [10.39, 7.98, 13.8],
      },
    },
    "W:1986-1990": {
      einfach: {
        "-55": [9.07, 7.05, 10.93],
        "55-60": [9.36, 7.37, 11.36],
        "60-65": [9.16, 6.69, 11.94],
        "65-70": [8.9, 5.62, 10.93],
        "70-75": [8.92, 6.59, 10.19],
        "75-85": [8.63, 7.1, 10.04],
        "85-95": [8.47, 5.72, 9.86],
        "95-": [8.75, 6.6, 10.81],
      },
      mittel: {
        "-50": [10.03, 8.04, 12.25],
        "50-55": [9.61, 7.98, 10.76],
        "55-60": [9.97, 8.87, 11.49],
        "60-65": [9.56, 7.93, 12.17],
        "65-70": [9.8, 7.79, 11.36],
        "70-105": [9.22, 7.18, 11.31],
        "105-": [9.8, 7.87, 11.58],
      },
      gut: {
        "-50": [11.13, 8.33, 14.96],
        "50-60": [10.34, 8.26, 14.45],
        "60-65": [10.57, 8.74, 12.75],
        "65-75": [11.06, 7.52, 13.21],
        "75-105": [10.63, 8.4, 13.96],
        "105-125": [12.15, 8.82, 16.1],
        "125-": [12.9, 8.07, 16.77],
      },
    },
    "O:1973-1990": {
      einfach: {
        "-40": [7.78, 6.82, 9.01],
        "40-60": [6.67, 6.07, 7.6],
        "60-100": [5.77, 5.2, 6.36],
        "100-": [5.6, 5.11, 6.0],
      },
      mittel: {
        "-40": [7.64, 6.63, 9.84],
        "40-60": [6.51, 5.92, 7.71],
        "60-": [5.89, 5.3, 6.63],
      },
      gut: {
        "-40": [7.79, 7.03, 9.2],
        "40-60": [7.07, 6.3, 9.28],
        "60-85": [6.18, 5.51, 7.23],
        "85-": [6.31, 5.26, 9.65],
      },
    },
    "1991-2001": {
      einfach: {
        "-55": [9.07, 7.05, 10.93],
        "55-60": [9.36, 7.37, 11.36],
        "60-65": [9.16, 6.69, 11.94],
        "65-70": [8.9, 5.62, 10.93],
        "70-75": [8.92, 6.59, 10.19],
        "75-85": [8.63, 7.1, 10.04],
        "85-95": [8.47, 5.72, 9.86],
        "95-": [8.75, 6.6, 10.81],
      },
      mittel: {
        "-50": [10.03, 8.04, 12.25],
        "50-55": [9.61, 7.98, 10.76],
        "55-60": [9.97, 8.87, 11.49],
        "60-65": [9.56, 7.93, 12.17],
        "65-70": [9.8, 7.79, 11.36],
        "70-75": [9.54, 8.05, 10.7],
        "75-105": [9.38, 7.91, 10.92],
        "105-": [9.8, 7.87, 11.58],
      },
      gut: {
        "-50": [11.13, 8.33, 14.96],
        "50-60": [10.34, 8.26, 14.45],
        "60-65": [10.57, 8.74, 12.75],
        "65-75": [11.06, 7.52, 13.21],
        "75-105": [10.63, 8.4, 13.96],
        "105-125": [12.15, 8.82, 16.1],
        "125-": [12.9, 8.07, 16.77],
      },
    },
    "2002-2009": {
      einfach: {
        "-55": [9.07, 7.05, 10.93],
        "55-60": [9.36, 7.37, 11.36],
        "60-65": [9.16, 6.69, 11.94],
        "65-70": [8.9, 5.62, 10.93],
        "70-75": [8.92, 6.59, 10.19],
        "75-85": [8.63, 7.1, 10.04],
        "85-95": [8.47, 5.72, 9.86],
        "95-": [8.75, 6.6, 10.81],
      },
      mittel: {
        "-50": [10.03, 8.04, 12.25],
        "50-55": [9.61, 7.98, 10.76],
        "55-60": [9.97, 8.87, 11.49],
        "60-65": [9.56, 7.93, 12.17],
        "65-70": [9.8, 7.79, 11.36],
        "70-": [10.61, 6.89, 15.04],
      },
      gut: {
        "-75": [10.91, 8.62, 13.92],
        "75-105": [11.85, 7.88, 16.83],
        "105-125": [12.15, 8.82, 16.1],
        "125-": [12.9, 8.07, 16.77],
      },
    },
    "2010-2015": {
      einfach: {
        "0-": [10.38, 7.5, 15.91],
      },
      mittel: {
        "-70": [12.6, 9.19, 17.6],
        "70-95": [11.39, 8.78, 15.64],
        "95-": [12.54, 9.88, 18.79],
      },
      gut: {
        "-60": [15.34, 8.99, 19.32],
        "60-85": [15.37, 9.99, 17.65],
        "85-110": [13.69, 8.89, 19.16],
        "110-": [15.15, 11.26, 17.82],
      },
    },
    "2016-2019": {
      einfach: {
        "0-": [12.77, 9.79, 18.19],
      },
      mittel: {
        "-70": [13.48, 10.08, 18.64],
        "70-95": [14.42, 10.24, 17.68],
        "95-": [13.18, 9.24, 20.88],
      },
      gut: {
        "-60": [17.23, 12.06, 26.05],
        "60-85": [18.94, 12.45, 23.43],
        "85-": [17.47, 10.91, 21.0],
      },
    },
    "2020-2024": {
      einfach: {
        "-60": [15.25, 9.99, 22.7],
        "60-80": [15.17, 9.37, 18.39],
        "80-": [14.11, 9.11, 19.28],
      },
      mittel: {
        "-50": [19.04, 12.52, 26.81],
        "50-65": [19.92, 10.78, 24.04],
        "65-95": [17.33, 12.48, 22.4],
        "95-": [15.15, 11.79, 21.02],
      },
      gut: {
        "-60": [22.59, 11.31, 27.84],
        "60-85": [19.54, 11.25, 26.69],
        "85-": [18.42, 10.28, 23.49],
      },
    },
  },
} satisfies {
  [Jahr in Mietspiegeljahr]: {
    [Baujahr in BaujahrSpanneInMietspiegeljahr[Jahr]]: {
      [Lage in Wohnlage]: Partial<{
        [Flaeche in Wohnflaeche]: Preisspanne;
      }>;
    };
  };
};
